import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

interface PublicMarkerPinIconProps extends SvgIconProps {
 fillColor?: string;
}

export const PublicMarkerPinIcon: FC<PublicMarkerPinIconProps> = ({ fillColor, ...props }) => {
  return (
    <SvgIcon
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M11 13.6123C11 8.85587 14.8559 5 19.6123 5C24.3688 5 28.2247 8.85587 28.2247 13.6123C28.2247 17.9063 25.0821 21.4663 20.9715 22.118V33.5566C20.9715 34.3076 20.3626 34.9164 19.6116 34.9164C18.8606 34.9164 18.2518 34.3076 18.2518 33.5566V22.1178C14.1418 21.4655 11 17.9058 11 13.6123Z" fill={fillColor} stroke={fillColor}/>
    </SvgIcon>
  )
}
